'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './client-edit.routes';

export class ClientSettingsEditComponent {
  constructor(SettingsService, Auth, $state, dialogs) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$state = $state;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("client")) {
        this.customSchema = customFieldSettings.data.client;
        this.customForm = ["*"];
      }
    });

    this.SettingsService.getByName({name: "client"}, data => {
      this.settings = data;

      this.schema = {
        type: "object",
        properties: {
          name: {
            type: "string",
            title: "Management Company Name"
          },
          address: {
            type: "string",
            title: 'Address of Management Company'
          },
          phone: {
            title: "Phone Number",
            type: "string"
          },
          fax: {
            title: "Fax Number",
            type: "string"
          },
          templateMailHeader: {
            title: "HTML Mail Header",
            type: "string",
            "x-schema-form": {
              type: "codemirror",
              codemirrorOptions: {
                "lineWrapping": true,
                "lineNumbers": true,
                "mode": "text/html",
                "styleActiveLine": true,
                "matchClosing": true,
                "tabSize": 2,
                "lint": true,
                "gutters": ["CodeMirror-lint-markers"]
              }
            }
          },
          customInvitation: {
            title: "Use Custom Invitation",
            type: "boolean"
          },
          customInvitationSubject: {
            title: "Invitation E-Mail Subject",
            type: "string",
            "x-schema-form": {
              condition: 'model.customInvitation'
            }
          },
          customInvitationTemplate: {
            title: "Invitation E-Mail Template",
            type: "string",
            "x-schema-form": {
              condition: 'model.customInvitation',
              type: "codemirror",
              codemirrorOptions: {
                "lineWrapping": true,
                "lineNumbers": true,
                "mode": "text/html",
                "styleActiveLine": true,
                "matchClosing": true,
                "tabSize": 2,
                "lint": true,
                "gutters": ["CodeMirror-lint-markers"]
              }
            }
          },
          customInvitationSuccessSubject: {
            title: "Invitation Success E-Mail Subject",
            type: "string",
            "x-schema-form": {
              condition: 'model.customInvitation'
            }
          },
          customInvitationSuccessTemplate: {
            title: "Invitation Success E-Mail Template",
            type: "string",
            "x-schema-form": {
              condition: 'model.customInvitation',
              type: "codemirror",
              codemirrorOptions: {
                "lineWrapping": true,
                "lineNumbers": true,
                "mode": "text/html",
                "styleActiveLine": true,
                "matchClosing": true,
                "tabSize": 2,
                "lint": true,
                "gutters": ["CodeMirror-lint-markers"]
              }
            }
          }
        }
      };

      let SPACER = {
        "type": "help",
        "helpvalue": "<br/>"
      };
      let LINE = {
        "type": "help",
        "helpvalue": "<hr/>"
      };

      this.form = [
        {
          "type": "tabs",
          "tabs": [
            {
              "title": "Basic",
              "items": [SPACER, "name", "address", "phone", "fax"]
            },
            {
              "title": "Invitation Mail",
              "items": [SPACER, "customInvitation", SPACER, "customInvitationSubject", "customInvitationTemplate", LINE,
                "customInvitationSuccessSubject", "customInvitationSuccessTemplate"]
            },
            {
              "title": "Advanced",
              "items": [SPACER, "templateMailHeader"]
            }]
        }
      ];

      this.model = this.settings.data;
      this.customFields = this.model.customFields || {};

      //delete and make generic for date fields
      if (this.customFields.dt) {
        console.log(this.customFields.dt);
        this.customFields.dt = new Date(this.customFields.dt);
        console.log(this.customFields.dt);
      }

    }, err => {
      console.log('Could not load settings from server');
    });
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The client settings have been changed successfully");
        dlg.result.then(() => {
          that.$state.go("home");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.settings.data = this.model;
      this.model.customFields = this.customFields || {};

      this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.clientSettingsEdit', [uiRouter])
  .config(routes)
  .component('clientSettingsEdit', {
    template: require('./client-edit.html'),
    controller: ClientSettingsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/client-edit/client-edit.component.js